import React, { useState } from 'react';
import { Button } from 'tea-component';
import classnames from 'classnames';
import NoData from '@gp/components/NoData';
import { splitFileName } from '@gp/utils/common';
import VideoImgContent from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/VisualShowcase/components/VideoImgContent';
import './index.scss';
import CardSlot from '@/pages/globalpedia/components/CardSlot';
import { useDeepCompareEffect } from 'ahooks';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import { getValidDate } from '@/pages/globalpedia/utils/common';

export default function VisualImg(props: any) {
  const {
    visualcaseData: visualcaseResData,
    getAdd,
    userIsAbleEdit,
    defaultVideoIndex = 0,
  } = props;

  const [visualDataList, setVisualDataList] = useState([]);
  const [selectItem, setSelectItem] = useState();

  // 把文件处理成一维数组，并a-z排序
  useDeepCompareEffect(() => {
    const list = visualcaseResData?.list || [];
    const resList: any = [];

    if (Array.isArray(list) && list?.length > 0) {
      list?.forEach((t: any) => {
        resList.push({
          ...t,
          id: t?.resource_id || '', // 这个id用于选中指定图片或视频
          title: splitFileName(t?.name)?.fileSuffixName || '',
          img: t?.resource_type === 2 ? t?.resource_cover : t?.resource_cover || t?.resource_url,
          time: t?.update_time,
          type: t?.resource_type,
          // 增加originalType字段，保存接口返回的原始type，下拉搜索框 添加搜索记录时 入参需要
          originalType: t?.resource_type,
          content_url: t?.resource_type === 2 ? t?.resource_url : '',
          isPlaying: false,
        });
      });
    }
    setVisualDataList(resList);
    setSelectItem(resList?.length > 0 ? resList?.[0] : {});
  }, [visualcaseResData]);

  const [currentVideoIndex, setCurrentVideoIndex] = useState(defaultVideoIndex);

  const handleVideoSelect = (item: any, index: any) => {
    setCurrentVideoIndex(index);
    const newListTemp = [...visualDataList];
    const newList: any = newListTemp?.map((item: any) => {
      return {
        ...item,
        isPlaying: false,
      };
    });
    setVisualDataList(newList);
    setSelectItem({
      ...item,
      isPlaying: false,
    });
  };

  const handlePlayPause = (playing: boolean) => {
    const newListTemp = [...visualDataList];
    const newList: any = newListTemp?.map((item: any, index: any) => {
      return {
        ...item,
        isPlaying: index === currentVideoIndex ? !playing : item.isPlaying,
      };
    });
    setVisualDataList(newList);
  };

  return (
    <>
      {!visualDataList?.length ? (
        <div className="dbg-project-detail-visual-showcase-datas">
          {/* <CardSlot className={classnames('dbg-project-detail-visual-showcase-card')}> */}
          <NoData
            className="dbg-project-detail-visual-showcase-nodata"
            text={
              userIsAbleEdit ? (
                <>
                  Please click the Edit button on the right or directly{' '}
                  <Button
                    type="link"
                    onClick={() => {
                      getAdd();
                    }}
                  >
                    add Visual Showcase.
                  </Button>
                </>
              ) : (
                <>No Data</>
              )
            }
            height={160}
          />
          {/* </CardSlot> */}
        </div>
      ) : (
        <div className="dbg-video-player-manager dbg-project-detail-visual-showcase-datas">
          {/* 预览侧边栏 */}
          <div className="dbg-preview-sidebar">
            <div className="dbg-preview-sidebar-inner">
              {visualDataList?.map((item: any, index: any) => (
                <div
                  key={index}
                  className={`dbg-preview-item ${index === currentVideoIndex ? 'dbg-active' : ''}`}
                  onClick={() => handleVideoSelect(item, index)}
                >
                  <div className="dbg-preview-video-container">
                    <VideoImgContent
                      data={item}
                      isLeftList={true}
                      isActive={index === currentVideoIndex}
                      // isPlaying={isPlaying}
                    />
                  </div>

                  <div className="dbg-video-info">
                    <EllipsisTextBubble
                      key={item.name}
                      className="item-source-title font14"
                      text={splitFileName(item.name)?.fileSuffixName || '-'}
                      isVisibleFixedCustomBubble={true}
                      customBubbleContent={
                        <div className="">
                          <div className="">{splitFileName(item.name)?.fileSuffixName || '-'}</div>
                          <div className="">{`Upload on ${getValidDate(
                            item.time,
                            'YYYY-MM-DD',
                          )}`}</div>
                        </div>
                      }
                    />
                    {/* <span className="dbg-video-info-name">
                      {splitFileName(item.name)?.fileSuffixName || ''}
                    </span> */}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="dbg-main-video-container">
            <VideoImgContent data={selectItem} handlePlayPause={handlePlayPause} />
          </div>
        </div>
      )}
    </>
  );
}
